import React from 'react';
import { type RouteObject } from 'react-router';
import { compact } from 'lodash';
import { PagePath, StaticPagesUrls } from '@monorepo/client-types';
import { StaticPage } from '@monorepo/react-components';
import { NavigationItem, Pages } from '@monorepo/types';
import { getProject } from '../helpers/get-project';

// Utility to generate static page routes
const getStaticPageRoutes = () => {
  const { project } = getProject();

  return Object.entries(StaticPagesUrls).map(([key, url]) => ({
    path: PagePath[key as keyof typeof PagePath],
    element: <StaticPage src={url[project]} />,
  }));
};

const getNavigationRoutes = (
  navigationItems: NavigationItem[],
  routeMap: Partial<Record<Pages, RouteObject>>,
): RouteObject[] => compact(navigationItems.map((item) => routeMap[item.page]));

// Helper for conditional route rendering
const createConditionalRoute = (
  condition: boolean,
  route: RouteObject,
  fallback: RouteObject,
) => (condition ? route : fallback);

const createAffiliationRoute = (
  featureEnabled: boolean,
  hasAffiliateId: boolean,
  dashboardComponent: React.ReactNode,
  welcomeComponent: React.ReactNode,
): RouteObject | undefined => {
  if (!featureEnabled) return undefined;

  return createConditionalRoute(
    hasAffiliateId,
    {
      path: PagePath.Affiliation,
      element: dashboardComponent,
    },
    {
      path: PagePath.Affiliation,
      element: welcomeComponent,
    },
  );
};

export {
  getStaticPageRoutes,
  getNavigationRoutes,
  createConditionalRoute,
  createAffiliationRoute,
};
